export default "__VITE_ASSET__B3Ztpy8C__"